import { FormSection } from '../../components/ui/FormSection';

interface FoodServiceSectionProps {
  foodAvailableForPurchase: boolean;
  onFoodAvailableForPurchaseChange: (value: boolean) => void;
  foodDescription: string;
  onFoodDescriptionChange: (value: string) => void;
}

export const FoodServiceSection = ({
  foodAvailableForPurchase,
  onFoodAvailableForPurchaseChange,
  foodDescription,
  onFoodDescriptionChange,
}: FoodServiceSectionProps) => (
  <FormSection title="Food Service">
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        id="foodAvailable"
        checked={foodAvailableForPurchase}
        onChange={(e) => onFoodAvailableForPurchaseChange(e.target.checked)}
        className="h-4 w-4"
      />
      <label htmlFor="foodAvailable" className="text-sm font-medium text-gray-700">
        Food Available for Purchase
      </label>
    </div>

    {foodAvailableForPurchase && (
      <div>
        <label htmlFor="foodDescription" className="block text-sm font-medium text-gray-700 mb-1">
          Food Description
        </label>
        <textarea
          id="foodDescription"
          value={foodDescription}
          onChange={(e) => onFoodDescriptionChange(e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="Describe the food options available"
        />
      </div>
    )}
  </FormSection>
);
